import type { AlertNotificationRule } from '@/api/fe-api/domain/entities/alert-notifications';
import { GetAllSites } from '@/api/fe-api/view/queries/get-all-sites';
import { ShowSkeleton } from '@/components/ui/old/ShowSkeleton';

import { BadgeListCollapsed } from './badge-list-collapsed';

export type AssetListProps = {
  data: AlertNotificationRule;
};

export function AssetList({ data }: AssetListProps) {
  const assets = GetAllSites.useQuery();

  if (data.siteIds.length === 0) {
    return <div>All assets</div>;
  }

  if (assets.isLoading) {
    return (
      <ShowSkeleton>
        <BadgeListCollapsed
          items={data.siteIds.map((siteId) => ({
            key: siteId,
            value: <div className="skeleton">{siteId}</div>,
          }))}
        />
      </ShowSkeleton>
    );
  }

  return (
    <BadgeListCollapsed
      items={data.siteIds.map((siteId) => ({
        key: siteId,
        value: assets.data?.find((site) => site.id === siteId)?.name || siteId,
      }))}
    />
  );
}
